export default __webpack_public_path__ + "static/media/hutch_ozdil.77e61674.jpg";